import { Hub } from '@bimone/bimtrack-core';
import { DateTime } from '@bimone/bimtrack-dates';
import DataCentersAssembler from './DataCentersAssembler';
import { HubDto } from './types';

class HubAssembler {
  public toDomain(dto: HubDto): Hub {
    return new Hub({
      hashId: dto.Id,
      name: dto.Name,
      avatarImage: dto.Image?.ThumbnailUrl,
      creationDate: DateTime.fromISOString(dto.CreationDate),
      dataCenterInfo: DataCentersAssembler.toDomain(dto.RegionSummary),
      bimTrackRegionalApiUrl: dto.RegionSummary.ApiRegionalUrl,
    });
  }
}

export default new HubAssembler();
